import { graphql, useStaticQuery } from 'gatsby'

const useCategories = () => {
  const {
    allContentfulCategory: { edges },
  } = useStaticQuery(
    graphql`
      query SiteCategoriesQuery {
        allContentfulCategory(
          filter: {
            node_locale: { eq: "fr" }
            contentfulparent: { id: { eq: null } }
          }
        ) {
          edges {
            node {
              slug
              title
            }
          }
        }
      }
    `
  )

  return edges.map(({ node: { slug, title } }) => ({
    slug,
    title,
  }))
}

export default useCategories
